//version=1.0.0
window.isDebug = false;

(function () {
    function init() {
        document.querySelectorAll('.toggletip').forEach((toggletip, i) => {
            const name = toggletip.innerText;
            const id = `${name.toLowerCase().replace(' ', '_')}-${i}`;
            const content = toggletip.getAttribute('data-tooltip-content');
            if (!content) {
                toggletip.classList.remove('toggletip');
                return;
            }

            toggletip.insertAdjacentHTML("afterend", tooltipContainer(id, name, content));

            toggletip.setAttribute('aria-haspopup', true);
            toggletip.setAttribute('aria-describedby', id);
            toggletip.setAttribute('data-toggletip-active', false);
            toggletip.setAttribute('popovertarget', id);

            toggletip.parentElement.style.position = 'relative';
            toggletip.addEventListener('click', clickHandler);
        });
    }



    function tooltipContainer(id, name, content) {
        const title = name[0].toUpperCase() + name.slice(1);
        const container =
            `
        <div id="${id}" class="toggletip-container"  aria-hidden="true" role="tooltip">
            <div>
                <dd>${content}</dd>
            </div>
             <header>
                <dt aria-hidden="true">${title}</dt> 
                <button class="close" aria-label="close dialog">X</button>
            </header>
        </div>
        `;
        return container;
    }

    function clickHandler(e) {
        const toggle = e.target;
        const id = toggle.getAttribute('aria-describedby');
        const tip = document.getElementById(id);

        // Calculate the vertical position of the toggletip
        const height = tip.offsetHeight;
        tip.getBoundingClientRect().top < height ? tip.classList.add('below') : tip.classList.remove('below');

        // Calculate the horizontal positions of the toggletip, tip, and parent container
        // The parent of the toggletip is set to position: relative; So the math is always relative to the parent container
        const windowWidth = window.innerWidth;
        const tipPosition = tip.getBoundingClientRect();
        const togglePosition = toggle.getBoundingClientRect();
        const parentPosition = toggle.parentElement.getBoundingClientRect();

        const tipWidth = tipPosition.width;
        const toggleWidth = togglePosition.width;
        const parentWidth = parentPosition.width;
        const relativeTipPosition = togglePosition.left - parentPosition.left;


        if (window.isDebug) {
            window.moveLeft = (amount) => tip.style.left = amount + 'px';
            window.moveRight = (amount) => tip.style.right = amount + 'px';
            window.toggle = toggle;
            window.tip = tip;


            console.log('TogglePositionLeft', togglePosition.left);
            console.log('ToggleWidth', toggleWidth);

            console.log('TipPositionLeft', tipPosition.left);
            console.log('TipWidth', tipWidth);

            console.log('toggleParentPositionLeft', parentPosition.left);
            console.log('toggleParentPositionRight', parentPosition.right);

            console.log('relativeTipPosition:', relativeTipPosition);
        }




        if (tipWidth + tipPosition.left > windowWidth) {
            // If the tip is larger than the window
            tip.style.width = windowWidth - 20 + 'px';
            tip.style.left = -parentPosition.left + 10 + 'px';
        } else if (relativeTipPosition + (toggleWidth / 2) - (tipWidth / 2) < 0) {
            // If the tip would go off the left side of the parent container
            tip.style.width = windowWidth - 20 + 'px';
            tip.style.left = -parentPosition.left + 10 + 'px';
        } else if (relativeTipPosition + (toggleWidth / 2) + (tipWidth / 2) > parentWidth) {
            // If the tip would to go off the right side of the parent container
            tip.style.left = parentWidth - tipWidth + 'px';
        } else {
            // Center the tip within the parent container
            tip.style.left = relativeTipPosition + (toggleWidth / 2) - (tipWidth / 2) + 'px';
        }





        const isActive = toggle.getAttribute('data-toggletip-active') === 'true';
        toggle.setAttribute('data-toggletip-active', !isActive);
        tip.setAttribute('aria-hidden', isActive);


        const closeHandler = () => {
            toggle.setAttribute('data-toggletip-active', false);
            tip.setAttribute('aria-hidden', true);
        };

        if (isActive) {tip.focus();}

        tip.addEventListener('keydown', () => {
            if (e.keyCode === 27) {
                closeHandler();
            }
        });

        tip.querySelector('.close').addEventListener('click', () => {
            toggle.focus();
            closeHandler();
        });

        document.addEventListener('click', function (e) {
            if (e.target !== toggle && tip.contains(e.target) === false) {
                closeHandler();
            }
        });
    }

    document.addEventListener('DOMContentLoaded', init);
})();


if (window.isDebug) {
    const title = document.querySelector('a.deptTitle');
    document.onmousemove = function (e) {
        var x = e.pageX;
        var y = e.pageY;
        title.innerText = "X " + x + ", Y " + y;
    };
}

